@if (formCtl !== null) {
  <ul class="error-list">
    @if (formCtl.touched && formCtl.hasError('required')) {
      <li @showHideTrigger>入力が必須です</li>
    }
    @if (formCtl.touched && formCtl.hasError('email')) {
      <li @showHideTrigger>
        メールアドレスのフォーマットが正しくありません
      </li>
    }
    @if (formCtl.touched && formCtl.hasError(INVALID_PHONE_NUMBER)) {
      <li @showHideTrigger>
        電話番号のフォーマットが正しくありません
      </li>
    }
    @if (formCtl.dirty && formCtl.hasError('maxlength')) {
      <li @showHideTrigger>{{ maxLengthErrorTxt }}</li>
    }
    @if (formCtl.dirty && formCtl.hasError('minlength')) {
      <li @showHideTrigger>{{ minLengthErrorTxt }}</li>
    }
    @if (formCtl.dirty && formCtl.hasError('max')) {
      <li @showHideTrigger>{{ maxErrorTxt }}</li>
    }
    @if (formCtl.dirty && formCtl.hasError('min')) {
      <li @showHideTrigger>{{ minErrorTxt }}</li>
    }
  </ul>
}
